/**
 * 分析記事IDとアフィリエイトページ（slug）の対応関係
 * 分析記事の詳細ページから関連するアフィリエイト記事へリンクするために使用
 */

/**
 * アフィリエイトマッピングの型定義
 */
export type AffiliateMapping = {
  slug: string;
  description: string;
};

/**
 * 分析記事IDをキー、アフィリエイトページ情報（slug、説明文）を値とするマッピング
 */
export const ANALYSIS_TO_AFFILIATE_MAP: Record<string, AffiliateMapping> = {
  // 【分析】映画『セブンティーン・アゲイン』（2009年公開）に学ぶ「魔法のランプ」の構造とプロットの鉄則
  QoR9FTFsswxjzoTfED0K: {
    slug: "golden-fleece",
    description:
      "この分析で登場している脚本術の書籍『SAVE THE CATの法則 本当に売れる脚本術』については、以下の記事でも取り上げています。本記事では「金の羊毛」というストーリージャンルについて解説しているので、興味のある方は是非ご覧ください！",
  },
    // ページをめくらせるには？1ページ目で読者を惹きつけるギャップを演出している漫画8作品
  vwBzbl96pd5Bnk5tTMG3: {
    slug: "fish-out-of-water",
    description:
      "この分析ではギャップを活用している映画を紹介していますが、このギャップの設定は“場違いな人（Fish Out of Water）”という映画手法として知らせています。興味のある方はぜひ以下の記事もご覧ください",
  },
  // インプットの姿勢
  // g70gWSGb8SyeINCuhyBy: {
  //   slug: "input-posture",
  //   description: "",
  // },
};

/**
 * 分析記事IDからアフィリエイトマッピング情報を取得
 * @param analysisId 分析記事のID
 * @returns アフィリエイトマッピング情報。対応がない場合はundefined
 */
export const getAffiliateMappingByAnalysisId = (
  analysisId: string
): AffiliateMapping | undefined => {
  return ANALYSIS_TO_AFFILIATE_MAP[analysisId];
};
